module.exports = __webpack_public_path__ + "img/bg.3b8f8513.png";